//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";
import { consentStyles } from "../styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Grid from "@material-ui/core/Grid";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import MenuItem from "@material-ui/core/MenuItem";
import Newsignaturelogo from 'assets/img/Henry Schein Thrive Service plus.png';

// material-ui icons

// custom TextField
const CssTextField = withStyles({
  root: {
    "& div.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormdiv-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: '5px !important',
      },
      marginTop: 0,
    },
  },
})(TextField);

export default function ThriveSignatureEnrollmentForm({ setNext, setStates, states }) {


  const classes = consentStyles();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [data, setData] = useState({ db: 'US' });

  const usStates = [
    { state: "Please Select", id: "Please Select" },
    { state: "Alabama", id: "AL" },
    { state: "Alaska", id: "AK" },
    { state: "Arizona", id: "AZ" },
    { state: "Arkansas", id: "AR" },
    { state: "California", id: "CA" },
    { state: "Colorado", id: "CO" },
    { state: "Connecticut", id: "CT" },
    { state: "Delaware", id: "DE" },
    { state: "Florida", id: "FL" },
    { state: "Georgia", id: "GA" },
    { state: "Hawaii", id: "HI" },
    { state: "Idaho", id: "ID" },
    { state: "Illinois", id: "IL" },
    { state: "Indiana", id: "IN" },
    { state: "Iowa", id: "IA" },
    { state: "Kansas", id: "KS" },
    { state: "Kentucky", id: "KY" },
    { state: "Louisiana", id: "LA" },
    { state: "Maine", id: "ME" },
    { state: "Maryland", id: "MD" },
    { state: "Massachusetts", id: "MA" },
    { state: "Michigan", id: "MI" },
    { state: "Minnesota", id: "MN" },
    { state: "Mississippi", id: "MS" },
    { state: "Missouri", id: "MO" },
    { state: "Montana", id: "MT" },
    { state: "Nebraska", id: "NE" },
    { state: "Nevada", id: "NV" },
    { state: "New Hampshire", id: "NH" },
    { state: "New Jersey", id: "NJ" },
    { state: "New Mexico", id: "NM" },
    { state: "New York", id: "NY" },
    { state: "North Carolina", id: "NC" },
    { state: "North Dakota", id: "ND" },
    { state: "Ohio", id: "OH" },
    { state: "Oklahoma", id: "OK" },
    { state: "Oregon", id: "OR" },
    { state: "Pennsylvania", id: "PA" },
    { state: "Rhode Island", id: "RI" },
    { state: "South Carolina", id: "SC" },
    { state: "South Dakota", id: "SD" },
    { state: "Tennessee", id: "TN" },
    { state: "Texas", id: "TX" },
    { state: "Utah", id: "UT" },
    { state: "Vermont", id: "VT" },
    { state: "Virginia", id: "VA" },
    { state: "Washington", id: "WA" },
    { state: "West Virginia", id: "WV" },
    { state: "Wisconsin", id: "WI" },
    { state: "Wyoming", id: "WY" }
  ];

  const handlesubmit = async () => {
    try {
      const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
      let error = false
      // if (states?.firstName == '') {
      //   setStates({
      //     nameError: true
      //   })
      //   error = true

      // }
      // if (states?.lastName == '') {
      //   setStates({
      //     nameError: true
      //   })
      //   error = true

      // }
      if (states?.officeNumber == '' || states?.officeNumber.length < 14) {
        setStates({
          officeNumberError: true
        })
        error = true
      }

      if (states?.email == '' || !regEx.test(states?.email)) {
        setStates({
          emailError: true
        })
        error = true
      }
      if (states?.practiceName == '') {
        setStates({
          practiceNameError: true
        })
        error = true
      }
      if (states?.streetAddress == '') {
        setStates({
          streetAddressError: true
        })
        error = true
      }
      if (states?.city == '') {
        setStates({
          cityError: true
        })

      }
      if (states?.state == '' || states?.state == 'Please Select') {
        setStates({
          stateError: true
        })
        error = true
      }
      if (states?.zipcode == '') {
        setStates({
          zipcodeError: true
        })
        error = true
      }
      // if (states?.subscribePlan == '') {
      //   setStates({
      //     subscribePlanError: true
      //   })
      //   error = true
      // }
      if (error) {
        return false
      } else {
        setStates({
          // nameError: false,
          officeNumberError: false,
          contactNumberError: false,
          emailError: false,
          // practiceNameError: false,
          streetAddressError: false,
          cityError: false,
          stateError: false,
          zipcodeError: false,
          // subscribePlanError: false,
          emailInvalidError: false

        })
        setNext('3')
      }
    }
    catch (e) {
      console.log({ e });
    }
  }

  const formatPhoneNumber = (value) => {
    const numbers = value.replace(/\D/g, "");

    if (numbers.length === 0) return "";

    if (numbers.length <= 3) {
      return `(${numbers}`;
    } else if (numbers.length <= 6) {
      return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
    } else {
      return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    setStates({ officeNumber: formattedValue, officeNumberError: false });
  };

  const handlePreferred = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    setStates({ contactNumber: formattedValue, contactNumberError: false });
  };

  return (
    <div style={{ width: '100%', margin: 'auto', marginRight: 'auto', background: '#fff', fontFamily: 'Inter, sans-serif' }}>
       <img style={{ width: "100%" }} src={Newsignaturelogo}></img>
      <Grid container alignItems="flex-start" className={classes.formtxtTop}>
        <React.Fragment>
          {/* <Grid container spacing={2} className={classes.formtxt1}>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
            <Grid item xs={12} lg={3} className={states?.nameError ? classes.formError1 : classes.formtxt}>
              <label className={classes.labelTxt}>
                Point of Contact <span style={{ color: 'red' }}>*</span></label>
              <CssTextField
                error={states?.nameError}
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states.firstName}
                onChange={(e) => {
                  const regex = /^[a-zA-Z]*$/;
                  if (regex.test(e?.target?.value)) {
                    setStates({
                      firstName: e?.target?.value,
                      pointOfContact: `${e.target.value} ${states.lastName}`,
                      nameError: false
                    })
                  }
                }}
                className={classes.textField}
              />
              <div style={{
                color: '#57647E',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '.75em',
                marginTop: 15
              }}>
                First Name
              </div>
              {states?.nameError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}
            </Grid>
            <Grid item xs={12} lg={3} className={states?.nameError ? classes.formError2 : classes.formtxt}>
              <label style={{ marginTop: '27px' }}>
                <span></span>
              </label>
              <CssTextField
                error={states?.nameError}
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states.lastName}
                onChange={(e) => {
                  const regex = /^[a-zA-Z]*$/;
                  if (regex.test(e?.target?.value)) {
                    setStates({
                      lastName: e?.target?.value,
                      pointOfContact: `${states.firstName} ${e.target.value} `,
                      nameError: false
                    })
                  }
                }
                }
                className={classes.textField}
              />
              <div style={{
                color: '#57647E',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '.75em',
                marginTop: 15
              }}>
                First Name
              </div>
            </Grid>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
          </Grid> */}

          <Grid container spacing={2} className={classes.formtxt1}>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
            <Grid item xs={12} lg={3} className={states?.officeNumberError ? classes.formError : classes.formtxt}>
              <label className={classes.labelTxt}>
                Office Number <span style={{ color: 'red' }}>*</span></label>
              <CssTextField
                error={states?.officeNumberError}
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states?.officeNumber}
                onChange={handleChange}

                placeholder="(100) 000-0000"

                className={classes.textField}
              />

              {states?.officeNumberError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}


            </Grid>
            <Grid item xs={12} lg={3} className={classes.formtxt}>
              <label className={classes.labelTxt}>
                Preferred Contact Number</label>
              <CssTextField
                error={states?.contactNumberError}
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states.contactNumber}
                onChange={handlePreferred}

                placeholder="(100) 000-0000"
                // onChange={(e)=>{
                //   const regex =  /^[0-9\s\-]*$/
                //   if (regex.test(e?.target?.value)) {
                //   setStates({
                //     contactNumber:e?.target?.value
                //   })
                // }
                // }
                // } 
                className={classes.textField}
              />
              {/* {states?.contactNumberError&& <div className={classes.errorTxt}><InfoOutlinedIcon
                              className={classes.emailInputIcon}
                            /><p>This field is required.</p></div>} */}



            </Grid>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
          </Grid>
          <Grid container spacing={2} className={classes.formtxt1}>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
            <Grid item xs={12} lg={3} className={(states?.emailError || states?.emailInvalidError) ? classes.formError : classes.formtxt}>
              <label className={classes.labelTxt}>
                Email <span style={{ color: 'red' }}>*</span></label>
              <CssTextField
                error={(states?.emailError || states?.emailInvalidError)}
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states.email}
                onChange={(e) => {
                  setStates({
                    email: e?.target?.value,
                    emailError: false
                  })
                }
                }

                className={classes.textField}
              />
              <label style={{
                color: '#57647E',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '.75em',
                marginTop: 5
              }}> example@example.com</label>
              {states?.emailError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}
              {states?.emailInvalidError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>Enter a valid e-mail address</p></div>}
            </Grid>
            <Grid item xs={12} lg={3} className={states?.streetAddressError ? classes.formError : classes.formtxt}>
              <label className={classes.labelTxt}>
                Street Address <span style={{ color: 'red' }}>*</span></label>
              <CssTextField
                error={states?.streetAddressError}
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states.streetAddress}
                onChange={(e) => {
                  setStates({
                    streetAddress: e?.target?.value,
                    streetAddressError: false
                  })
                }
                }
                className={classes.textField}
              />
              {states?.streetAddressError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}
            </Grid>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
          </Grid>
          <Grid container spacing={2} className={classes.formtxt1}>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
            <Grid item xs={12} lg={3} className={classes.formtxt}>
              <label className={classes.labelTxt}>
                Street Address Line 2</label>
              <CssTextField
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states.streetAddress2}
                onChange={(e) => {
                  setStates({
                    streetAddress2: e?.target?.value
                  })
                }}
              />
            </Grid>
            <Grid item xs={12} lg={3} className={states?.cityError ? classes.formError : classes.formtxt}>
              <label className={classes.labelTxt}>
                City <span style={{ color: 'red' }}>*</span></label>
              <CssTextField
                error={states?.cityError}
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states.city}
                onChange={(e) => {
                  const regex = /^[a-zA-Z\s]*$/;
                  if (regex.test(e?.target?.value)) {
                    setStates({
                      city: e?.target?.value,
                      cityError: false
                    })
                  }
                }
                }
                className={classes.textField}
              />
              {states?.cityError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}
            </Grid>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
          </Grid>
          <Grid container spacing={2} className={classes.formtxt1}>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
            <Grid item xs={12} lg={3} className={states?.stateError ? classes.formError : classes.formtxt}>
              <label className={classes.labelTxt}>
                State <span style={{ color: 'red' }}>*</span></label>
              <CssTextField
                select
                type={"text"}
                value={states.state}
                variant="outlined"
                onChange={(e) => {
                  setStates({
                    state: e.target.value,
                    stateError: false
                  })
                }}
              >
                {usStates.map((r, i) => (
                  <MenuItem value={r.id} key={t(r.id)}>
                    {t(r.id)}
                  </MenuItem>
                ))}
              </CssTextField>
              {states?.stateError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}
            </Grid>
            <Grid item xs={12} lg={3} className={states?.zipcodeError ? classes.formError : classes.formtxt}>
              <label className={classes.labelTxt}>
                Zip Code <span style={{ color: 'red' }}>*</span></label>
              <CssTextField
                error={states?.zipcodeError}
                type="text"
                autoComplete="off"
                variant="outlined"
                value={states.zipcode}
                onChange={(e) => {
                  const regex = /^[0-9\s\-]*$/
                  if (regex.test(e?.target?.value)) {
                    setStates({
                      zipcode: e?.target?.value,
                      zipcodeError: false
                    })
                  }
                }}
                className={classes.textField}
              />
              {states?.zipcodeError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}
            </Grid>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
          </Grid>
          <Grid container spacing={2} className={classes.formtxt1}>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
          </Grid>
          {/* <Grid container spacing={2} className={classes.formtxt2}>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
            <Grid item xs={12} lg={9} className={states?.subscribePlanError ? classes.formRadioError : classes.formtxtRadio}>
              <label className={classes.labelTxt}>
                Select Subscription Plan <span style={{ color: 'red' }}>*</span></label>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                // defaultValue={states?.subscribePlan}
                name="radio-buttons-group"
                value={states?.subscribePlan}
                column
                onChange={(e) => {

                  setStates({
                    subscribePlan: e?.target?.value,
                    subscribePlanError: false
                  })
                }
                }

              >
                <FormControlLabel value={'Monthly Plan: $99 per Month. No Commitment Required'} control={<Radio color="primary" />} label="Monthly Plan: $99 per Month. No Commitment Required" />
                <FormControlLabel value={'Yearly Plan: $1,188 per Year. Includes a yearly preventative maintenance (Labor only, Parts not included)'} control={<Radio color="primary" />} label="Yearly Plan: $1,188 per Year. Includes a yearly preventative maintenance (Labor only, Parts not included)" />
              </RadioGroup>
              {states?.subscribePlanError && <div className={classes.errorTxt}><InfoOutlinedIcon
                className={classes.emailInputIcon}
              /><p>This field is required.</p></div>}



            </Grid>
          </Grid> */}

          {/* <Grid container spacing={2} className={classes.formtxt1}>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
            <Grid item xs={12} lg={3} className={classes.formbtn}>
              <Button variant="contained" className={classes.backbtn} onClick={() => setNext('1')}>Back</Button>
            </Grid>
            <Grid item xs={12} lg={3} className={classes.formbtn}>
              <Button variant="contained" className={classes.nextbtn}
                onClick={() => handlesubmit()}
              >Next</Button>
            </Grid>
            <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
          </Grid> */}
          <div style={{
            border: '1px solid transparent',
            borderTopColor: '#ededf1',
            width: '50%',
            margin: 'auto',
            marginTop: 20,
            paddingTop: 25,
            display: 'flex',
            justifyContent: 'space-between'
          }}>
            <button style={{
              float: 'right',
              border: '1px solid transparent',
              minWidth: '128px',
              height: '3em',
              color: '#000',
              borderRadius: 4,
              background: '#e5e7f2',
              cursor: 'pointer'

            }} onClick={() => setNext('1')}>Back</button>

            <button style={{
              float: 'right',
              border: '1px solid transparent',
              minWidth: '128px',
              height: '3em',
              color: '#fff',
              borderRadius: 4,
              background: '#2e69ff',
              cursor: 'pointer'

            }} onClick={() => handlesubmit()}>Next</button>

          </div>
        </React.Fragment>
      </Grid>
    </div >
  );
}